<template>
  <div>
    <el-upload
      :action="actionUrl"
      list-type="picture-card"
      :accept="fileType"
      :multiple="true"
      :headers="headers"
      :with-credentials="true"
      :auto-upload="true"
      :limit="limit"
      :file-list="fileList"
      :disabled="boxType === 'view'"
      :on-success="handleSuccess"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-error="handleError"
      :on-exceed="handleExceed"
      :before-upload="beforeUpload"
      :class="fileList.length < limit ? '' : 'isHidden'"
    >
      <i class="el-icon-plus" />
      <div slot="tip" class="el-upload__tip">
        <div v-if="tagType && tagType() && tagTxt && tagTxt() && limit === 1 && boxType !== 'add' && init && !isEmpty(value)">
          <el-tag :type="tagType()" effect="dark">{{ tagTxt() }}</el-tag>
        </div>
        <span v-if="fileType">只能上传{{ fileType }}文件</span><span v-if="fileType && maxSize">，</span><span v-if="maxSize">文件不超过{{ maxSize }}kb</span>
      </div>
    </el-upload>
    <el-dialog
      top="10vh"
      title="预览图片"
      :modal="false"
      :modal-append-to-body="false"
      :visible.sync="dialogVisible"
    >
      <img
        style="object-fit: contain; width: 100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>

<script>
import isEmpty from 'vue-lodash'
export default {
  name: 'DyFileUpload',
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    limit: {
      type: Number,
      default: 2
    },
    value: {
      type: [Array, String],
      default: () => []
    },
    tagType: {
      type: Function,
      default: undefined
    },
    tagTxt: {
      type: Function,
      default: undefined
    },
    biztype: {
      type: String,
      default: ''
    },
    boxType: {
      type: String,
      default: ''
    },
    labelInValue: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: String,
      default: 'image/*'
    },
    maxSize: {
      type: [Number, undefined],
      default: undefined
    }
  },
  data() {
    return {
      actionUrl: '',
      baseUrl: process.env.VUE_APP_BASE_API,
      fileList: [],
      dialogImageUrl: undefined,
      dialogVisible: false,
      init: true,
      headers: {
        Authorization: this.$store.state.user.token // 从本地获取token就行
      }
    }
  },
  watch: {
    value: {
      handler() {
        console.log('watch')
        this.initFileList()
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    console.log('created')
    // this.initFileList()
    this.actionUrl = `${this.baseUrl}/api/v1/file/upload`
    if (this.biztype) this.actionUrl += `?biztype=${this.biztype}`
    console.log('this.biztype: ', this.biztype)
  },
  methods: {
    isEmpty,
    initFileList() {
      console.log('initFileList: ')
      console.log('this.init: ', this.init)
      console.log('this.value: ', this.value)
      if (this.init) {
        console.log('handlerhandlerthis.value: ', this.value)
        this.fileList = []
        if (this.value && this.value !== '' && typeof this.value === 'string') {
          try {
            const obj = JSON.parse(this.value)
            // var obj = JSON.parse(str)
            if (typeof obj === 'object' && obj) {
              const values = JSON.parse(this.value)
              if (typeof values[0] === 'string') {
                this.fileList = values.map(i => {
                  return {
                    uid: 1747645087081,
                    url: i
                  }
                })
              } else if (typeof values[0] === 'object') {
                this.fileList = values
              }
            }
          } catch (e) {
            console.error('不是json格式')
            this.fileList = [{
              url: this.value
            }]
          }
          console.log('1111111111this.fileList: ', this.fileList)
        }
      }
      // this.init = false
    },
    beforeUpload(file) {
      console.log('file: ', file)
      console.log('file: ', file)
      console.log('this.maxSize: ', this.maxSize)
      if (this.maxSize && file.size > this.maxSize * 1024) {
        this.$message.warning(`文件最大不能超过${this.maxSize}Kb`)
        return false
      }
      this.init = false
      return true
    },
    async httpUpload(file) {
      // const uploadFileRes = await common.attachUpload(this.ossParams, file)
      // return Promise.resolve(uploadFileRes)
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove(file, fileList) {
      this.init = false
      console.log(file, fileList)
      this.fileList = fileList
      if (this.limit === 1) {
        this.$emit('change', undefined)
      } else {
        if (this.labelInValue) {
          this.$emit(
            'change', fileList
          )
        } else {
          this.$emit(
            'change',
            fileList.map(i => i.url)
          )
        }
      }
    },
    handleError(response, file, fileList) {
      console.error('error', response)
    },
    handleSuccess(response, file, fileList) {
      file.url = response
      console.log('this.limit: ', this.limit)
      console.log('this.labelInValue: ', this.labelInValue)
      if (this.limit === 1) {
        this.$emit('change', response)
      } else {
        if (this.labelInValue) {
          this.$emit(
            'change',
            fileList.map(i => {
              // i.url = response
              return i
            })
          )
        } else {
          this.$emit(
            'change',
            fileList.map(i => i.url)
          )
        }
      }
      console.log('fileList: ', fileList)
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 ${this.limit} 个文件，本次选择： ${
          files.length
        } 个，已选：${fileList.length}个，超过了${
          fileList.length + files.length - this.limit
        }个`
      )
    }
  }
}
</script>

<style scoped lang="scss">
.isHidden {
  .el-upload--picture-card {
    display: none;
  }
  ::v-deep .el-upload--picture-card{
    display: none;
  }
}
</style>
